export default __webpack_public_path__ + "media/4ccfc1493e8a742004b866c71b66b62454084a7d8f9f5ea82c461dc4c595073e.svg";